import React from 'react';
import classNames from 'classnames';
import { useWindowWidth } from '@distribute/frontend/utils';
import {
  pagesModel,
  QUERY_PARAM_CURRENT_OPENED_TAB,
  QUERY_PARAM_OPENED_TASK,
} from '../../../../features/pages';
import { useSelector } from 'react-redux';
import { APP_ORIGIN } from '../../../../shared/config';
import { teamsModel } from '../../../../features/teams';

const LOCAL_SUBDOMAIN = 'dev';

const getPreviewSrc = (subdomain: string, pageId: string | number) => {
  const urlParams = new URLSearchParams(window.location.search);
  const taskId = urlParams.get(QUERY_PARAM_OPENED_TASK);
  const tab = urlParams.get(QUERY_PARAM_CURRENT_OPENED_TAB);

  const queryParamsString =
    tab && taskId
      ? `?${QUERY_PARAM_CURRENT_OPENED_TAB}=${tab}&${QUERY_PARAM_OPENED_TASK}=${taskId}`
      : '';

  if (subdomain === LOCAL_SUBDOMAIN) {
    return `http://${LOCAL_SUBDOMAIN}.${APP_ORIGIN}/draft/${pageId}${queryParamsString}`;
  }
  return `https://${subdomain}.${APP_ORIGIN}/draft/${pageId}${queryParamsString}`;
};

type IframeSizes = {
  width: number | '100%';
  height: number | '100%';
};

const tabletSizes: IframeSizes = {
  width: 728,
  height: 932,
};

const mobileSizes: IframeSizes = {
  width: 350,
  height: 812,
};

type Props = {
  pageId: string;
  title?: string;
};

export const PreviewPage: React.FC<Props> = ({ pageId, title }) => {
  const { domain: currentTeamDomain } = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const { isMobile } = useWindowWidth();
  const activePreview = useSelector(
    pagesModel.selectors.selectEditorPreviewMode
  );

  const desktopPreview = activePreview === 'Desktop';
  const tabletPreview = activePreview === 'Tablet';

  const getIframeSizes = (): IframeSizes => {
    if (desktopPreview || isMobile) {
      return { width: '100%', height: '100%' };
    }
    if (tabletPreview) {
      return tabletSizes;
    }

    return mobileSizes;
  };
  const iframeSizes = getIframeSizes();

  return (
    <div className="flex flex-col h-full grow-1">
      <div
        className={classNames(
          'flex flex-col justify-center grow-1 h-full sm:p-0'
        )}
      >
        <div
          className={classNames(
            'flex flex-col grow-1 w-full relative h-full items-center justify-center',
            {
              'py-2': !desktopPreview,
            }
          )}
        >
          <iframe
            key={activePreview}
            allow="clipboard-read; clipboard-write;"
            className={classNames(`sm:border-none sm:rounded-none`, {
              'border-base-black-8 border rounded-lg bg-base-white':
                !desktopPreview && !isMobile,
            })}
            height={iframeSizes.height}
            width={iframeSizes.width}
            title={title || 'Untitled'}
            src={getPreviewSrc(currentTeamDomain, pageId)}
          />
        </div>
      </div>
    </div>
  );
};
